import React from "react";
import RewardNAWarningModal from "app/features/Rewards/RewardNAWarningModal";
import RewardsBanner from "app/features/Rewards/RewardsBanner";
import { RewardsDetails } from "app/features/Rewards/types/RewardsDetails";
import { setHasRewaredSelected, updateSelectedReward } from "app/store/slices/rewardsSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { RewardWallet } from "store/slices/tOrderTypes";
import { updateRewardSelectedOnPage } from "store/slices/tOrderSlice";

type RewardsHeaderSectionProps = {
    wallets: RewardWallet[] | null
    isCartPage?: boolean
};

export default function RewardsHeaderSection(
    { wallets, isCartPage = false }:RewardsHeaderSectionProps,
) {
    const dispatch = useAppDispatch();
    const walletCode = useAppSelector((state) => state.rewards.selectedReward.rewardId);
    const storeNumber = useAppSelector(
        (state) => state.stores.storeNumber || state.stores.storeId,
    );
    const isRewardApplicable = !!(storeNumber && walletCode);
    const isRewardInValid = wallets?.every(
        (wallet) => wallet.categoryItemCodes.length === 0,
    ) ?? false;
    const onRewardNAWarningModalClose = () => {
        dispatch(setHasRewaredSelected(false));
        dispatch(updateSelectedReward({} as RewardsDetails));
        dispatch(updateRewardSelectedOnPage(false));
    };
    if (!wallets || !isRewardApplicable) {
        return null;
    }
    return (
        <div className={isCartPage ? 'mb-2' : ""}>
            <RewardNAWarningModal
                showRewardNAWarningModal={isRewardApplicable && isRewardInValid}
                onRewardNAWarningModalClose={onRewardNAWarningModalClose}
            />
            {
                (isRewardApplicable && !isRewardInValid)
                && (
                    <RewardsBanner isCartPage={isCartPage} />
                )
            }
        </div>
    );
}
